import React from 'react';
import {Link} from 'react-router-dom';
import {scrollToElement} from '../api/functions';
import docsrc from "../../images/filetypes/docx.svg";

class ProgramDetailBlock extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const data = this.props.initialState;
        return (
            <div className="container">
                <div className="program-detail">
                    <div className="program-detail__top">

                        {data.img && <div className="program-detail__img">
                            <img src={`https://copp72.ru${data.img}`} alt=""/>
                        </div>}

                        <div className="program-detail__info">
                            {data.competence && <div className="program-detail__competence">
                                Компетенция: {data.competence}
                            </div>}

                            {data.duration && <div className="program-detail__duration">{data.duration}<i>ч</i></div>}

                            {data.title && <h1 className="program-detail__title">{data.title}</h1>}

                            {data.subtitle && <div className="program-detail__subtitle">{data.subtitle}</div>}

                            {data.shortDescription && <div className="program-detail__short-description">
                                <span dangerouslySetInnerHTML={{__html: data.shortDescription}}/>
                            </div>}

                            {data.description && <div className="program-detail__detail-link"
                                                      onClick={() => scrollToElement(this.descriptionBlock)}>подробнее
                            </div>}

                            {data.price && <div className="program-detail__price">{data.price}<i>*</i></div>}

                            <Link to='/work/app/catalog' className="program-detail__return">
                                <svg width="17" height="12" viewBox="0 0 17 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M17.001 7.01401H2.98098L6.36898 10.853L5.11998 12.001L0.719981 7.01401H0.00598145V4.98201H0.663981L5.16298 -0.00299072L6.43998 1.14401L2.97598 4.98201H17.001V7.01401Z"
                                          fill="#778899"/>
                                </svg>

                                Вернуться в программы
                            </Link>
                        </div>
                    </div>

                    {data.description && <div className="program-detail-description">
                        <div className="block-title" ref={this.descriptionBlock}>Описание программы</div>

                        <div className="program-detail-description__text"
                             dangerouslySetInnerHTML={{__html: data.description}}/>
                    </div>}

                    {data.programFile && <a href={data.programFile} className="program-detail__program-file">
                        Скачать программу

                        <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M7.01702 16.336V16.994H4.98502V16.28L-0.000976562 11.881L1.14602 10.631L4.98502 14.019V0H7.01702V14.024L10.856 10.56L12.003 11.837L7.01702 16.336Z"
                                  fill="#d0101b"/>
                        </svg>
                    </a>}

                    {data.docFile && <div className="program-detail-doc">
                        <div className="program-detail-doc__img">
                            <img src={docsrc} alt=""/>
                        </div>

                        <div className="program-detail-doc__text">
                            <div className="program-detail-doc__title">Документ об окончании</div>
                            <a href={data.docFile} className="program-detail-doc__link">Свидетельство о профессиональной
                                переподготовке</a>
                        </div>
                    </div>}
                </div>
            </div>
        )
    }
}

export {ProgramDetailBlock}
